import {ChevronLeftIcon, ChevronRightIcon} from "@heroicons/react/20/solid";
import {OtsActionButton, OtsIconActionButton} from "./OtsButton";
import {OtsDatePicker} from "./OtsDatePicker";

export type OtsDayStepperProps = {
  /** The day shown, in the viewer's local calendar. */
  value: Date;
  onChange: (value: Date) => void;
  /** "Today" for the Today shortcut; injectable for tests and stories. */
  today?: Date;
  size?: "compact" | "default";
  disabled?: boolean;
  className?: string;
};

const shiftDays = (date: Date, days: number) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
const sameDay = (a: Date, b: Date) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

/** Steps a day-based view backwards and forwards, with the date picker for a jump and a Today shortcut. */
export const OtsDayStepper = ({value, onChange, today = new Date(), size = "default", disabled, className}: OtsDayStepperProps) => (
  <div className={["inline-flex items-center gap-1", className].filter(Boolean).join(" ")}>
    <OtsIconActionButton
      variant="text"
      size={size}
      disabled={disabled}
      icon={<ChevronLeftIcon/>}
      label="Previous day"
      onClick={() => onChange(shiftDays(value, -1))}/>
    <OtsDatePicker
      label="Day"
      hideLabel
      required
      size={size}
      disabled={disabled}
      value={value}
      onChange={(next) => next && onChange(next)}
      className="w-40"/>
    <OtsIconActionButton
      variant="text"
      size={size}
      disabled={disabled}
      icon={<ChevronRightIcon/>}
      label="Next day"
      onClick={() => onChange(shiftDays(value, 1))}/>
    <OtsActionButton
      variant="text"
      size={size}
      disabled={disabled || sameDay(value, today)}
      onClick={() => onChange(new Date(today.getFullYear(), today.getMonth(), today.getDate()))}>
      Today
    </OtsActionButton>
  </div>
);
